export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Industries, job roles, regions, qualifications, experience levels, driving
// licence and work preference lists come from the backend: see hooks/useCareerCatalogue.

export const RELOCATE_OPTIONS = ["Yes", "No"];

export const JOB_TYPES = ["Full-time", "Part-time"];

export const CONTRACT_TYPES = [
  "Permanent", "Fixed-term", "Contract / Freelance", "Internship", "Apprenticeship",
];

export const LOCATION_TYPES = ["On-site", "Hybrid", "Remote"];

export const JOB_STATUSES = ["active", "draft", "closed"];

export const TRANSFERABLE_SKILLS = [
  "Communication", "Teamwork", "Problem Solving", "Leadership",
  "Time Management", "Adaptability", "Critical Thinking", "Creativity",
  "Attention to Detail", "Customer Service", "Organisation", "Initiative",
  "Resilience", "Negotiation", "Presentation Skills", "Project Management",
  "Data Analysis", "Conflict Resolution", "Mentoring", "Research",
  "IT Literacy", "Commercial Awareness", "Networking", "Report Writing",
  "Decision Making", "Emotional Intelligence", "Analytical Thinking", "Strategic Planning",
];

export const WORK_EXPERIENCE_TYPES = [
  "Full-Time Permanent",
  "Apprenticeship (Level 1-2)",
  "Apprenticeship (Level 3-5)",
  "Apprenticeship (Level 6-7)",
  "Short-term Work Experience (1-2 weeks)",
  "Volunteer Work Experience",
];

// Shown when the backend refuses a request with 403.
export const FORBIDDEN_MESSAGE = "You don't have permission to do that.";
